import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a4f9484"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app" }

import useStore from './hooks/useStore';
import { computed,onMounted } from 'vue'
import { LightVars, DarkVars } from './config/CssVar';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

// Vant格式化主题值
const formatTheme = computed(() => {
  return store.state.setting.isDark ? 'dark' : ''
});

// 根据当前语言来初始化vant组件库的语言
store.commit('setting/setVantLanguage');

// 初始化加载时根据仓库值设置主题颜色
onMounted(() => {
  const html = document.documentElement;
  const vars = store.state.setting.isDark ? DarkVars : LightVars;
  Object.entries(vars).forEach(([ key, value ]) => {
    html.style.setProperty(key,value)
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_config_provider = _resolveComponent("van-config-provider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_config_provider, { theme: _unref(formatTheme) }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }, 8, ["theme"])
  ]))
}
}

})